<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed z-40 inset-0 overflow-y-auto">
            <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0" @click="close">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div :style="containerStyle" class="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 w-full sm:max-w-lg">
                        <!-- Barra superior - exibida apenas se showHeader for true -->
                        <div v-if="showHeader" class="py-4 px-4 sm:px-6 sm:rounded-md" :style="headerStyle">
                            <div class="flex items-center justify-between">
                                <DialogTitle :class="titleClass">
                                    {{type == 'create' ? 'New '+title :  type == 'update' ? 'Update '+title : title }}
                                </DialogTitle>
                                <div class="ml-3 h-7 flex items-center">
                                    <button type="button" :class="closeButtonClass" @click="close">
                                        <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Botão de fechar flutuante - exibido apenas se showHeader for false -->
                        <div v-if="!showHeader" class="absolute top-10 right-10 z-10">
                            <button 
                                type="button" 
                                class="bg-white bg-opacity-90 backdrop-blur-sm rounded-full p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 shadow-lg transition-all" 
                                @click="close"
                            >
                                <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                        
                        <div>
                            <slot/>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>


<script>

import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline';

export default {

  name: 'Modal',

    props: {
      formClose: {
        type: Function,
        default: () => {},
      },
      open: {
          type: Boolean,
          default: false,
      },
      title: {
          type: String,
          default: '',
      },
      type: {
          type: String,
      },
      showHeader: {
          type: Boolean,
          default: true,
      },
      headerBgColor: {
          type: String,
          default: null,
      },
      headerTextColor: {
          type: String,
          default: null,
      },
      maxWidth: {
          type: String,
          default: null,
      }
    },

    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        XMarkIcon,
    },
    computed: {
        headerStyle() {
            const style = {};
            if (this.headerBgColor) {
                style.backgroundColor = this.headerBgColor;
            }
            return style;
        },
        titleClass() {
            return [
                'text-lg font-medium', 
                this.headerTextColor ? `text-${this.headerTextColor}` : 'text-gray-800'
            ];
        },
        closeButtonClass() {
            return [
                'rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300',
                this.headerBgColor ? 'text-white hover:text-gray-200' : 'bg-white text-gray-400 hover:text-gray-800'
            ];
        },
        containerStyle() {
            const style = {};
            
            if (this.maxWidth) {
                style.maxWidth = this.maxWidth;
                style.margin = '0 auto';
            }
            
            return style;
        }
    },
    methods: {
      close() {
        try {
          if (typeof this.formClose === 'function') {
            this.formClose();
          } else {
            console.warn('formClose não é uma função válida');
          }
        } catch (error) {
          console.error('Erro ao fechar o modal:', error);
        }
      },
    },

}
</script>